import './WriteCell.sass';

import React, { FC, useCallback } from 'react';
import { Link, useRoute } from 'react-router5';

import { WriteCellProps } from '$core/Write/WriteCell/WriteCell.interface';
import { useUserInfo } from '$hooks';
import { Online, UnitName } from '$shared/components';
import { CHAT } from '$shared/constants/pages';
import { IcChevron16 } from '$assets';
import { useDispatch, useSelector } from 'react-redux';
import { attachActions } from '$store/attach';

export const WriteCell: FC<WriteCellProps> = ({ userId, onClick }) => {
  const user = useUserInfo(userId);
  const { route } = useRoute();
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    if (route.params.share) {
      //const matches = route.params.share.match(/^(\w+)(\d+)$/);
      const url = `https://${location.host}${
        /personal_subscription/.test(route.params.share)
          ? `/s/${route.params.id}`
          : `/feed?w=${route.params.share}`
      }`;

      dispatch(
        attachActions.loadLink({
          pickerId: `im_${userId}`,
          link: url,
        }),
      );
    }
  }, [route]);

  return (
    <Link
      routeName={CHAT}
      routeParams={{ peerId: userId }}
      routeOptions={{ replace: true }}
      className="WriteCell"
      onClick={() => {
        onClick ? onClick(userId) : handleClick();
      }}
    >
      <div
        className="WriteCell__photo"
        style={{ backgroundImage: `url(${user.photo})` }}
      />
      <div className="WriteCell__cont">
        <div className="WriteCell__name_wrap">
          <div className="WriteCell__name">
            <UnitName unit={user} />
          </div>
          <Online userId={userId} />
        </div>
      </div>
      <div className="WriteCell__arrow">
        <IcChevron16 />
      </div>
    </Link>
  );
};
